import {Injectable} from "@angular/core";
import {ProductDetails} from "@app/core/product/domain/dtos/product-details";
import {ProductComparisonLocal} from "@app/core/product/domain/repositories/product-comparison.local";
import {Observable, ReplaySubject} from "rxjs";
import {LargeStorageLocal} from '@app/core/shared/domain/storage/large-storage.local';

@Injectable({
    providedIn: 'root'
})
export class ProductComparisonLocalStorage implements ProductComparisonLocal{
    private PRODUCTS_COMPARISON_KEY = 'products-comparison';

    private comparisonProductsSubject = new ReplaySubject<ProductDetails[]>(1);
    comparisonProducts$: Observable<ProductDetails[]> = this.comparisonProductsSubject.asObservable();


    constructor(
        private localStorage:LargeStorageLocal
    ) {
        this.updateObservable();
    }

    private getProductsFromLocalStorage(): ProductDetails[] {
        const productsString = this.localStorage.getItem(this.PRODUCTS_COMPARISON_KEY)
        if(productsString) {
            return JSON.parse(productsString);
        }
        return [];
    }

    private updateObservable() {
        this.comparisonProductsSubject.next(this.getProductsFromLocalStorage())
    }

    addProduct(productDetails:ProductDetails): void {
        let products = this.getProductsFromLocalStorage();

        if(products.find(productInComparison => productInComparison.code === productDetails.code)) {
            return;
        }

        products.push(productDetails)
        this.localStorage.setItem(this.PRODUCTS_COMPARISON_KEY,JSON.stringify(products))
        this.updateObservable();
    }

    getProducts(): Observable<ProductDetails[]> {
        return this.comparisonProducts$;
    }

    deleteProduct(productCode:string): void {
        let productsComparison = this.getProductsFromLocalStorage() || [];
        const newProductsComparison = productsComparison.filter(
            productInComparison => productInComparison.code !== productCode
        );
        this.localStorage.setItem(this.PRODUCTS_COMPARISON_KEY,JSON.stringify(newProductsComparison))
        this.updateObservable();
    }
}
